/* fifteen52 YMM — modal + header + neutral PDP prompt + safe redirect */
(function () {
  'use strict';

  // ---------------- Config
  var LS_KEY = 'f52ymm:selectedVehicle';   // header/PDP legacy
  var SS_KEY = 'f52ymmVehicle';            // PDP evaluator
  var JSON_URL =
    window.f52ymmYmmJsonUrl ||
    (window.f52ymmOptionsBaseUrl
      ? window.f52ymmOptionsBaseUrl + '/ymm/ymm-options.json'
      : null);

  var _lastOpener = null;
  var _ymmTree = null;      // { years:[], makesByYear:{}, modelsByYearMake:{} }
  var _rawYmmData = null;   // original feed
  var _loadPromise = null;

  window.f52ymmDebug = window.f52ymmDebug ?? false;

  // ---------------- Helpers
  function $(sel) { return document.querySelector(sel); }
  function slugify(s) {
    return String(s || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function toNum(v) { var n = Number(v); return Number.isFinite(n) ? n : null; }

  // ---------------- Storage
  function getSelectedVehicle() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function setSelectedVehicle(v) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch(e){}
    try { sessionStorage.setItem(SS_KEY, JSON.stringify(v)); } catch(e){}

    f52ymm_setHeaderVehicleDataset(v);

    try { window.dispatchEvent(new CustomEvent('f52ymm:selectionChanged', { detail: { vehicle: v }})); } catch(e){}
    try { document.dispatchEvent(new CustomEvent('f52ymm:vehicleSaved', { detail: v })); } catch(e){}
  }
  function clearSelectedVehicle() {
    try { localStorage.removeItem(LS_KEY); } catch(e){}
    try { sessionStorage.removeItem(SS_KEY); } catch(e){}

    f52ymm_setHeaderVehicleDataset(null);

    try { window.dispatchEvent(new CustomEvent('f52ymm:selectionChanged', { detail: { vehicle: null }})); } catch(e){}
    try { document.dispatchEvent(new CustomEvent('f52ymm:vehicleCleared')); } catch(e){}
  }

  // Header dataset helper
  function f52ymm_setHeaderVehicleDataset(v) {
    var el = document.getElementById('f52ymm-selector');
    if (!el) return;
    if (!v) {
      delete el.dataset.year;
      delete el.dataset.make;
      delete el.dataset.makeId;
      delete el.dataset.modelId;
      delete el.dataset.model;
      return;
    }
    el.dataset.year    = v.year ?? v.yearRaw ?? '';
    el.dataset.make    = v.make ?? v.makeRaw ?? '';
    el.dataset.makeId  = v.makeId ?? v.makeRaw ?? '';
    el.dataset.modelId = v.modelId ?? v.modelRaw ?? '';
    el.dataset.model   = v.model ?? v.modelRaw ?? '';
  }

  // ---------------- JSON helpers
  function findMakeBlock(make) {
    if (!_rawYmmData || !_rawYmmData.makes) return null;
    var want = String(make || '').toLowerCase();
    for (var i = 0; i < _rawYmmData.makes.length; i++) {
      var m = _rawYmmData.makes[i];
      if (m && String(m.title || '').toLowerCase() === want) return m;
    }
    return null;
  }
  function modelIncludesYear(rec, selectedYear) {
    var year = Number(selectedYear);
    if (!Number.isFinite(year)) return true;

    if (Array.isArray(rec && rec.years) && rec.years.length) {
      return rec.years.some(function(y){ return Number(y) === year; });
    }

    var first = Number(rec && (rec.first_year || rec.from_year));
    var last = Number(rec && (rec.last_year || rec.to_year));
    if (Number.isFinite(first) && year < first) return false;
    if (Number.isFinite(last) && year > last) return false;
    return true;
  }
  function findModelRecord(makeBlock, model, selectedYear, modelId) {
    if (!makeBlock) return null;
    var want = String(model || '').toLowerCase();
    var wantSlug = slugify(want);
    var wantId = modelId == null ? '' : String(modelId);
    var models = Array.isArray(makeBlock.models) ? makeBlock.models : [];
    var idMatch = null, exact = null, slugMatch = null, prefixMatch = null;

    for (var j = 0; j < models.length; j++) {
      var rec = models[j] || {};
      if (!modelIncludesYear(rec, selectedYear)) continue;
      var t = String(rec.title || '');
      var tl = t.toLowerCase();
      if (wantId && String(rec.id) === wantId) { idMatch = rec; break; }
      if (!exact && tl === want) exact = rec;
      if (!slugMatch && slugify(t) === wantSlug) slugMatch = rec;
      if (!prefixMatch && tl.indexOf(want) === 0) prefixMatch = rec;
    }
    return idMatch || exact || slugMatch || prefixMatch || null;
  }
  function getModelYearRange(info) {
    if (!info) return null;
    var yrs = [];
    if (Array.isArray(info.years) && info.years.length) {
      for (var i = 0; i < info.years.length; i++) yrs.push(Number(info.years[i]));
    }
    if (info.first_year || info.last_year || info.from_year || info.to_year) {
      var fy = Number(info.first_year || info.from_year || 0);
      var ly = Number(info.last_year  || info.to_year  || 0);
      if (fy > 0) yrs.push(fy);
      if (ly > 0) yrs.push(ly);
    }
    yrs = yrs.filter(function(n){ return Number.isFinite(n) && n > 0; });
    if (!yrs.length) return null;
    return { min: Math.min.apply(null, yrs), max: Math.max.apply(null, yrs) };
  }
  function collectionExists(pathOrHandle) {
    var handle = String(pathOrHandle)
      .replace(/^https?:\/\/[^/]+/i, '')
      .replace(/^\/collections\//, '')
      .replace(/^\//, '')
      .replace(/\/$/, '');
    var url = '/collections/' + handle + '.json';
    return fetch(url, { method: 'GET', cache: 'no-store' })
      .then(function(r){ return r && r.ok; })
      .catch(function(){ return false; });
  }
  function findBestCollectionPath(make, model, selectedYear) {
    var mkBlock = findMakeBlock(make);
    var info = findModelRecord(mkBlock, model, selectedYear);

    var mk = slugify(make);
    var md = slugify(model);
    var candidates = [];

    if (info && info.collection_url) {
      var cleanUrl = info.collection_url.replace(location.origin, '');
      candidates.push(cleanUrl);
    }
    if (info && info.collection_handle) candidates.push('/collections/' + info.collection_handle);

    var rng = getModelYearRange(info);
    var sel = Number(selectedYear || 0);
    function handleFor(minY, maxY) {
      return 'aftermarket-wheels-for-' + minY + '-to-' + maxY + '-' + mk + '-' + md;
    }
    function noRangeHandle() {
      return 'aftermarket-wheels-for-' + mk + '-' + md;
    }

    if (rng) {
      candidates.push('/collections/' + handleFor(rng.min, rng.max));
      if (sel && sel >= rng.min && sel <= rng.max && sel < rng.max) {
        candidates.push('/collections/' + handleFor(rng.min, sel));
      }
      if (sel && sel >= rng.min && sel <= rng.max) {
        var capsTried = {};
        function tryCap(cap){
          if (!capsTried[cap]) {
            capsTried[cap] = true;
            candidates.push('/collections/' + handleFor(rng.min, cap));
          }
        }
        var guessCaps = [sel + 1, sel + 2, sel + 3, 2023, 2024, 2025, rng.max]
          .filter(function(y){ return Number.isFinite(y) && y >= sel && y <= rng.max; })
          .slice(0, 5);
        for (var i = 0; i < guessCaps.length; i++) tryCap(guessCaps[i]);
      }
    }

    candidates.push('/collections/' + noRangeHandle());

    var seen = {};
    candidates = candidates.filter(function(p){
      if (seen[p]) return false;
      seen[p] = true;
      return true;
    });

    var idx = 0;
    function tryNext() {
      if (idx >= candidates.length) return Promise.resolve(candidates[candidates.length - 1]);
      var path = candidates[idx++];
      return collectionExists(path).then(function(ok){
        return ok ? path : tryNext();
      });
    }
    return tryNext();
  }
  function getModelMeta(makeTitle, modelTitle, selectedYear, modelId) {
    var meta = { first: null, last: null, handle: null, path: null };
    try {
      var mkBlock = findMakeBlock(makeTitle);
      var rec = findModelRecord(mkBlock, modelTitle, selectedYear, modelId);
      if (rec) {
        if (Number.isFinite(+rec.first_year)) meta.first = +rec.first_year;
        if (Number.isFinite(+rec.last_year))  meta.last  = +rec.last_year;

        if (rec.shopify_collection_handle) {
          meta.handle = String(rec.shopify_collection_handle);
          meta.path = '/collections/' + meta.handle;
        } else if (rec.collection_handle) {
          meta.handle = String(rec.collection_handle);
          meta.path = '/collections/' + meta.handle;
        } else if (rec.collection_url) {
          meta.path = String(rec.collection_url).replace(location.origin, '');
          meta.handle = meta.path.replace(/^\/collections\//, '').replace(/^\//, '');
        }
      }
    } catch (e) {}
    return meta;
  }

  // ---------------- Modal
  function openModal() {
    var modal = document.getElementById('f52ymm-modal');
    var shade = document.getElementById('f52ymm-body-screen');

    if (modal) {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      modal.setAttribute('aria-modal', 'true');
    }
    if (shade) shade.classList.add('visible');
    try { document.body.style.overflow = 'hidden'; } catch (e) {}

    ensureYmmLoaded()
      .then(function(){ populateYearSelect(); })
      .then(function(){
        var first = document.getElementById('f52ymm-modal-select-year') ||
                    (modal && modal.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'));
        if (first && first.focus) first.focus({ preventScroll: true });
      })
      .catch(function(e){ console.error(e); });
  }
  function closeModal() {
    var modal = document.getElementById('f52ymm-modal');
    var shade = document.getElementById('f52ymm-body-screen');

    if (modal) {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    }
    if (shade) shade.classList.remove('visible');
    try { document.body.style.overflow = ''; } catch (e) {}

    if (_lastOpener && _lastOpener.focus) {
      try { _lastOpener.focus(); } catch(e) {}
    }
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && document.getElementById('f52ymm-modal')?.classList.contains('open')) {
      closeModal();
    }
  });

  // ---------------- Behavior: toggle click should redirect if selected, otherwise open modal
  function goToSelectedVehicleCollection(v) {
    if (!v) return;

    var meta = getModelMeta(v.make, v.model, v.year, v.modelId);
    if (meta && meta.path) {
      window.location.href = meta.path;
      return;
    }

    findBestCollectionPath(v.make, v.model, v.year).then(function (path) {
      window.location.href = path;
    });
  }

  function openModalOrGoToCollection(openerEl) {
    var v = getSelectedVehicle();

    if (v) {
      goToSelectedVehicleCollection(v);
      return;
    }

    _lastOpener = openerEl || null;
    openModal();
  }

  function bindModalToggles() {
    // Event delegation so any current or future button works
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.f52ymm-selector-modal-toggle');
      if (!btn) return;

      // If click came from a clear button, let clear handlers run
      if (e.target.closest('.f52ymm-selector-vehicle-clear') || e.target.closest('.f52ymm-announcement-clear')) {
        return;
      }

      e.preventDefault();
      openModalOrGoToCollection(btn);
    });

    var closeBtn = document.getElementById('f52ymm-modal-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    var shade = document.getElementById('f52ymm-body-screen');
    if (shade) {
      shade.addEventListener('click', function (e) {
        if (e.target === e.currentTarget) closeModal();
      });
    }
  }

  // ---------------- Header sync
  function syncHeaderFromSelection() {
    var container = document.getElementById('f52ymm-selector');
    if (!container) return;
    var v = getSelectedVehicle();
    var nameEl = container.querySelector('.f52ymm-selected-name');

    if (v) {
      container.classList.add('is-verified', 'f52ymm-has-selection');
      if (nameEl) nameEl.textContent = (v.year || '') + ' ' + (v.make || '') + ' ' + (v.model || '');
      f52ymm_setHeaderVehicleDataset(v);
    } else {
      container.classList.remove('is-verified', 'f52ymm-has-selection');
      if (nameEl) nameEl.textContent = '';
      f52ymm_setHeaderVehicleDataset(null);
    }
  }

  function bindHeaderClear() {
    // Delegate so it survives header re-renders
    document.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('#f52ymm-selector .f52ymm-selector-vehicle-clear');
      if (!clearBtn) return;

      e.preventDefault();
      e.stopPropagation();

      clearSelectedVehicle();
      syncHeaderFromSelection();
      evaluatePdp();

      _lastOpener = clearBtn;
      openModal();
    });
  }

  // ---------------- PDP state (neutral, evaluator owns fit/no-go)
  function evaluatePdp() {
    var pdp = document.getElementById('f52ymm-pdp');
    if (!pdp) return;

    var v = getSelectedVehicle();
    var verified = pdp.querySelector('.f52ymm-selector-vehicle-verified');
    var warning  = pdp.querySelector('.product-warning');

    if (verified) verified.classList.remove('visible');
    if (warning)  warning.classList.remove('visible');

    if (!v && warning) {
      warning.innerHTML =
        '<div class="warning-row">' +
          '<span class="warning-icon" aria-hidden="true"></span>' +
          '<span class="warning-text">Select vehicle to confirm fitment.</span>' +
          '<button type="button" class="f52ymm-selector-modal-toggle warning-button">Verify Vehicle</button>' +
        '</div>';
      warning.classList.add('visible');

      var openBtn = warning.querySelector('.f52ymm-selector-modal-toggle');
      if (openBtn) {
        openBtn.addEventListener('click', function (e) {
          e.preventDefault();
          _lastOpener = e.currentTarget || e.target;
          openModal();
        });
      }
    }
  }

  // ---------------- Load + normalize feed
  function ensureYmmLoaded() {
    if (_ymmTree) return Promise.resolve(_ymmTree);
    if (_loadPromise) return _loadPromise;
    if (!JSON_URL) return Promise.reject(new Error('YMM JSON URL is not set'));

    _loadPromise = fetch(JSON_URL, { credentials: 'omit', cache: 'force-cache' })
      .then(function (r) { if (!r.ok) throw new Error('YMM fetch failed'); return r.json(); })
      .then(function (data) {
        _rawYmmData = data;
        window.f52YmmRaw = data;
        _ymmTree = normalizeYmm(data);
        return _ymmTree;
      });
    return _loadPromise;
  }
  function normalizeYmm(data) {
    var yearsSet = {};
    var makesByYear = {};
    var modelsByYearMake = {};

    function add(y, m, md) {
      if (y == null || m == null || md == null) return;
      y = String(y).trim();
      m = String(m).trim();
      md = String(md).trim();
      yearsSet[y] = true;
      if (!makesByYear[y]) makesByYear[y] = {};
      makesByYear[y][m] = true;
      var key = y + '|' + m;
      if (!modelsByYearMake[key]) modelsByYearMake[key] = {};
      modelsByYearMake[key][md] = true;
    }

    if (Array.isArray(data)) {
      for (var i = 0; i < data.length; i++) add(data[i].year, data[i].make, data[i].model);
    } else if (data && Array.isArray(data.vehicles)) {
      for (var j = 0; j < data.vehicles.length; j++) add(data.vehicles[j].year, data.vehicles[j].make, data.vehicles[j].model);
    } else if (data && data.years && typeof data.years === 'object') {
      for (var y in data.years) {
        var makes = data.years[y] || {};
        for (var mk in makes) {
          var models = makes[mk] || [];
          for (var k = 0; k < models.length; k++) add(y, mk, models[k]);
        }
      }
    } else if (data && Array.isArray(data.makes)) {
      var fy = Number(data.from_year) || 1900;
      var ty = Number(data.to_year) || (new Date()).getFullYear();

      function yearsFromModel(mo) {
        if (mo && Array.isArray(mo.years) && mo.years.length) return mo.years;
        var start = Number(mo && mo.first_year) || Number(mo && mo.from_year) || fy;
        var end   = Number(mo && mo.last_year)  || Number(mo && mo.to_year)  || ty;
        if (!(start && end && end >= start)) return [];
        var arr = [];
        for (var yy = end; yy >= start; yy--) arr.push(yy);
        return arr;
      }

      for (var mi = 0; mi < data.makes.length; mi++) {
        var makeObj = data.makes[mi] || {};
        var makeTitle = makeObj.title || '';
        var modelsArr = Array.isArray(makeObj.models) ? makeObj.models : [];
        for (var mj = 0; mj < modelsArr.length; mj++) {
          var modelObj = modelsArr[mj] || {};
          var modelTitle = modelObj.title || '';
          var yrs = yearsFromModel(modelObj);
          for (var yi = 0; yi < yrs.length; yi++) add(yrs[yi], makeTitle, modelTitle);
        }
      }
    }

    var years = Object.keys(yearsSet).sort(function (a, b) { return Number(b) - Number(a); });
    var makesByYearOut = {};
    for (var y2 in makesByYear) makesByYearOut[y2] = Object.keys(makesByYear[y2]).sort();
    var modelsByYearMakeOut = {};
    for (var key in modelsByYearMake) modelsByYearMakeOut[key] = Object.keys(modelsByYearMake[key]).sort();

    return { years: years, makesByYear: makesByYearOut, modelsByYearMake: modelsByYearMakeOut };
  }

  // ---------------- Modal bindings
  var els = {};
  function cacheEls() {
    els.year  = document.getElementById('f52ymm-modal-select-year');
    els.make  = document.getElementById('f52ymm-modal-select-make');
    els.model = document.getElementById('f52ymm-modal-select-model');
    els.save  = document.getElementById('f52ymm-modal-save');
    els.form  = document.getElementById('f52ymm-form');
  }
  function resetSelect(select, placeholder) {
    if (!select) return;
    select.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder || 'Select...';
    opt.selected = true;
    select.appendChild(opt);
  }
  function populateYearSelect() {
    cacheEls();
    if (!els.year) return;
    resetSelect(els.make, 'Make...');
    resetSelect(els.model, 'Model...');
    if (els.make) els.make.disabled = true;
    if (els.model) els.model.disabled = true;
    if (els.save)  els.save.disabled = true;

    var tree = _ymmTree;
    if (!tree) return;

    resetSelect(els.year, 'Year...');
    for (var i = 0; i < tree.years.length; i++) {
      var o = document.createElement('option');
      o.value = tree.years[i];
      o.textContent = tree.years[i];
      els.year.appendChild(o);
    }
  }
  function onYearChange() {
    var y = els.year.value;
    resetSelect(els.make, 'Make...');
    resetSelect(els.model, 'Model...');
    if (els.save) els.save.disabled = true;

    if (!y) { if (els.make) els.make.disabled = true; if (els.model) els.model.disabled = true; return; }

    var makes = _ymmTree.makesByYear[y] || [];
    for (var i = 0; i < makes.length; i++) {
      var o = document.createElement('option');
      o.value = makes[i];
      o.textContent = makes[i];
      els.make.appendChild(o);
    }
    if (els.make) els.make.disabled = false;
    if (els.model) els.model.disabled = true;
  }
  function onMakeChange() {
    var y = els.year.value;
    var m = els.make.value;
    resetSelect(els.model, 'Model...');
    if (els.save) els.save.disabled = true;

    if (!y || !m) { if (els.model) els.model.disabled = true; return; }

    var key = y + '|' + m;
    var models = _ymmTree.modelsByYearMake[key] || [];
    for (var i = 0; i < models.length; i++) {
      var o = document.createElement('option');
      o.value = models[i];
      o.textContent = models[i];
      els.model.appendChild(o);
    }
    if (els.model) els.model.disabled = false;
  }
  function onModelChange() {
    if (els.save) els.save.disabled = !els.model.value;
  }

  function getVehicleFromUI() {
    cacheEls();
    var yearVal  = els.year  ? els.year.value  : '';
    var makeVal  = els.make  ? els.make.value  : '';
    var modelVal = els.model ? els.model.value : '';

    if (yearVal && makeVal && modelVal) {
      return {
        year: toNum(yearVal) ?? yearVal,
        make: makeVal,
        model: modelVal,
        makeId: null,
        modelId: null,
        yearRaw: yearVal,
        makeRaw: makeVal,
        modelRaw: modelVal
      };
    }

    var header = document.getElementById('f52ymm-selector');
    if (header?.dataset?.year && (header.dataset.make || header.dataset.makeId) && header.dataset.modelId) {
      return {
        year: toNum(header.dataset.year) ?? header.dataset.year,
        make: header.dataset.make || '',
        model: header.dataset.model || '',
        makeId: toNum(header.dataset.makeId) ?? header.dataset.makeId,
        modelId: toNum(header.dataset.modelId) ?? header.dataset.modelId,
        yearRaw: header.dataset.year,
        makeRaw: header.dataset.makeId || header.dataset.make,
        modelRaw: header.dataset.modelId
      };
    }

    return null;
  }

  function bindForm() {
    cacheEls();
    if (!els.form) return;
    if (els._bound) return;
    els._bound = true;

    if (els.year)  els.year.addEventListener('change', onYearChange);
    if (els.make)  els.make.addEventListener('change', onMakeChange);
    if (els.model) els.model.addEventListener('change', onModelChange);

    els.form.addEventListener('submit', function (e) {
      e.preventDefault();

      var v = getVehicleFromUI();
      if (!v) { console.warn('YMM save blocked. Missing selection.'); return; }

      setSelectedVehicle(v);
      syncHeaderFromSelection();
      evaluatePdp();

      var noRedirect = false;
      if (_lastOpener && _lastOpener.getAttribute) {
        noRedirect = _lastOpener.getAttribute('data-ymm-redirect-after-selection') === 'false';
      }
      if (noRedirect) { closeModal(); return; }

      var meta = getModelMeta(v.make, v.model, v.year, v.modelId);
      if (meta && meta.path) {
        if (window.f52ymmDebug) console.log('[YMM] redirect via JSON handle ->', meta.path);
        window.location.href = meta.path;
        return;
      }
      if (meta && meta.first && meta.last) {
        var handle = 'aftermarket-wheels-for-' + meta.first + '-to-' + meta.last + '-' + slugify(v.make) + '-' + slugify(v.model);
        if (window.f52ymmDebug) console.log('[YMM] redirect via JSON range ->', handle);
        window.location.href = '/collections/' + handle;
        return;
      }
      findBestCollectionPath(v.make, v.model, v.year).then(function(path) {
        if (window.f52ymmDebug) console.log('[YMM] redirect via probe finder ->', path);
        window.location.href = path;
      });
    });
  }

  // ---------------- Boot
  function boot() {
    bindModalToggles();
    bindHeaderClear();
    bindForm();
    syncHeaderFromSelection();
    evaluatePdp();
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
    if (JSON_URL) { ensureYmmLoaded().catch(function(e){ console.error(e); }); }

    var raw = null;
    try { raw = sessionStorage.getItem(SS_KEY) || localStorage.getItem(LS_KEY); } catch(e){}
    if (raw) {
      try {
        var v = JSON.parse(raw);
        document.dispatchEvent(new CustomEvent('f52ymm:vehicleRestored', { detail: v }));
      } catch(e){}
    }
  });

  window.addEventListener('f52ymm:selectionChanged', function () {
    syncHeaderFromSelection();
    evaluatePdp();
  });

  window.f52Ymm = {
    getSelectedVehicle: getSelectedVehicle,
    setSelectedVehicle: setSelectedVehicle,
    clearSelectedVehicle: clearSelectedVehicle,
    openModal: openModal,
    closeModal: closeModal
  };
})();

// Global YMM feed location for PDP and header
window.f52ymmYmmJsonUrl = window.f52ymmYmmJsonUrl || 'https://dlnatixo3b4u4.cloudfront.net/ymm/ymm-options.json';
